import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hca-settings',
  templateUrl: './hca-settings.component.html',
  styleUrls: ['./hca-settings.component.scss']
})
export class HcaSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/settings/hca-settings/hca-settings.component.ts